export default __webpack_public_path__ + "static/media/snow.0db9b9da.mp4";